import { POS_TYPES_FETCH_POS_TYPES } from '../action-types/pos-types';

const initialState = {
  entities: [],
  loading: false,
  loaded: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case POS_TYPES_FETCH_POS_TYPES.REQUEST:
      return {
        ...state,
        loading: true,
        loaded: false,
      };
    case POS_TYPES_FETCH_POS_TYPES.SUCCESS:
      return {
        ...state,
        entities: action.payload,
        loading: false,
        loaded: true,
      };
    case POS_TYPES_FETCH_POS_TYPES.REJECTED:
      return {
        ...state,
        entities: [],
        loading: true,
        loaded: false,
      };
    default:
      return state;
  }
}
